import { z } from "zod";
import type { Operation } from "../../types";
import { helpExternalLinkRowSchema, helpIdParams } from "./_shared";

const list: Operation<
  void,
  { enabled_only?: boolean; include_archived?: boolean },
  void,
  { links: z.infer<typeof helpExternalLinkRowSchema>[] }
> = {
  method: "GET",
  path: () => "/api/help/links",
  query: z
    .object({
      enabled_only: z.coerce.boolean().optional(),
      include_archived: z.coerce.boolean().optional(),
    })
    .partial(),
  response: z.object({ links: z.array(helpExternalLinkRowSchema) }),
};

const set: Operation<
  void,
  void,
  {
    kind: string;
    url: string;
    label: string;
    description?: string | null;
    icon?: string | null;
    enabled?: boolean;
    sort_key?: string;
  },
  z.infer<typeof helpExternalLinkRowSchema>
> = {
  method: "POST",
  path: () => "/api/help/links",
  body: z.object({
    kind: z.string().min(1),
    url: z.string(),
    label: z.string().min(1),
    description: z.string().nullable().optional(),
    icon: z.string().nullable().optional(),
    enabled: z.boolean().optional(),
    sort_key: z.string().optional(),
  }),
  response: helpExternalLinkRowSchema,
  // upsert into the collection (set creates-or-updates by kind).
  invalidates: [list],
};

const archive: Operation<
  { id: number },
  void,
  void,
  z.infer<typeof helpExternalLinkRowSchema>
> = {
  method: "POST",
  path: ({ id }) => `/api/help/links/${id}/archive`,
  params: helpIdParams,
  response: helpExternalLinkRowSchema,
  invalidates: [list],
};

export const links = { list, set, archive };
